<template>
  <div class="material-management">
    <div class="material-container">
      <div class="left-container">
        <div class="add-type-content">
          <div v-if="typeList.length > 0">
            <div class="search-type">
              <el-input
                class="gray white"
                placeholder="输入搜索内容"
                prefix-icon="el-icon-search"
                v-model="searchType"
                clearable
                @keyup.enter.native="initMaterialTypeList"
              >
              </el-input>
            </div>
            <div
              :class="activeIndex === index?'active type':'type'"
              v-for="(item,index) in typeList"
              :key="index"
              @click="selectType(index, item)"
            >
              <div class="type-title">
                <img src="../../../../assets/tree/random.png">
                <div>{{item.name}}</div>
              </div>
              <el-dropdown
              v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleAddRenameDelMaterialCategory
                ) !== -1
              "
                trigger="click"
                @command="handleCommand"
              >
                <span class="el-dropdown-link">
                  <img src="../../../../assets/tree/three-spot.png">
                </span>
                <el-dropdown-menu slot="dropdown">
                  <el-dropdown-item :command="beforeHandleCommand(item, 'mod')" class="mod">重命名</el-dropdown-item>
                  <el-dropdown-item :command="beforeHandleCommand(item, 'delete')" class="delete">删除</el-dropdown-item>
                </el-dropdown-menu>
              </el-dropdown>
            </div>
          </div>
          <div class="nothing-add" v-if="typeList.length == 0">
            <div>
              <div>
                <img src="../../../../assets/nothing-add.png">
              </div>
              <p>请先增分类</p>
            </div>
          </div>
        </div>
        <el-button
          v-if="
            OPERATION_LIST.findIndex(
              (item) => item === OPERATIONS_BTNS.roleAddRenameDelMaterialCategory
            ) !== -1
          "
          type="text"
          class="btn-border-text-blue add-type"
          @click="addType"
          >新增分类</el-button
        >
      </div>

      <div class="right-container">
        <div class="top-container">
          <div class="title">物料表格</div>
          <div class="search">
            <el-button
              v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleAddDelMaterial
                ) !== -1
              "
              type="text"
              class="btn-blue add"
              icon="el-icon-plus"
              @click="openAddMaterial"
              >添加</el-button
            >
          </div>
        </div>
        <div class="table" v-if="tableData.length > 0">
          <el-table :data="tableData" style="width: 100%">
            <el-table-column
              v-for="(item, index) in tableTitleList"
              :key="index"
              :prop="item.prop"
              :label="item.lable"
              :width="item.width"
              :show-overflow-tooltip="item.showOverflowTooltip"
            />
            <el-table-column label="逐日推销">
              <template slot-scope="scope">
                <el-switch
                  v-model="scope.row.amortizationByDay"
                  @change="changeStatus(scope.row.id)"
                ></el-switch>
              </template>
            </el-table-column>
            <el-table-column label="操作" width="120"
            
              v-if="
                OPERATION_LIST.findIndex(
                  (item) => item === OPERATIONS_BTNS.roleAddDelMaterial
                ) !== -1
              "
            >
              <template slot-scope="scope">
                <i class="el-icon-delete" @click="remove(scope.row.id)"></i>
              </template>
            </el-table-column>
          </el-table>
        </div>
        <div class="nothing" v-if="tableData.length == 0">
          <div>
            <div>
              <img src="../../../../assets/nothing.png">
            </div>
            <p>暂无数据</p>
          </div>
        </div>
      </div>
    </div>

    <!-- 新增分类和重命名物料名称 -->
    <el-dialog
      :title="dialogTitle"
      :visible.sync="dialogVisible"
      width="540px"
      :before-close="handleClose"
    >
      <el-form
        :model="form"
        :rules="rules"
        ref="form"
      >
        <el-form-item v-if="isAddType == 2" label="物料名称" prop="materialName">
          <el-input class="gray white" v-model="form.materialName"></el-input>
        </el-form-item>
        <el-form-item v-else label="分类名称" prop="typeName">
          <el-input class="gray white" v-model="form.typeName"></el-input>
        </el-form-item>
      </el-form>
      <span slot="footer" class="dialog-footer">
        <el-button @click="dialogVisible = false">取 消</el-button>
        <el-button type="primary" @click="confirm('form')">确 定</el-button>
      </span>
    </el-dialog>
  </div>
</template>

<script>
import { config } from '@/common/js/config.js'
import { operationMixins } from '@/common/mixins/operation/operation.js'
import PaginationTpl from "@/components/PaginationTpl.vue";
import Material from "@/models/material.js";
export default {
  mixins: [operationMixins],
  components: {
    PaginationTpl
  },

  data() {
    return {
      tableData: [],
      tableTitleList: [
        { prop: "name", lable: "物料名称", width: "", showOverflowTooltip:false },
      ],
      searchType: '',
      activeIndex: '',
      // 分类集合
      typeList: [],
      // 分类id
      typeId: '',
      dialogVisible: false,
      dialogTitle: '新增分类',
      // 是否是新增分类; 1.是 2.新增物料; 3.修改分类名称
      isAddType: 1,
      form: {
        typeName: '',
        materialName: '',
      },
      rules: {
        typeName: [{ required: true, message: "请输入名称", trigger: "blur" }],
        materialName: [{ required: true, message: "请输入名称", trigger: "blur" }],
      },
    }
  },

  created() {
    config()
    this.initMaterialTypeList()
  },

  methods: {
    /* 获取物料分类 */
    initMaterialTypeList() {
      let name = this.searchType
      Material.getMaterialTypeList(name).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.name = i.name
            arr.push(obj)
          })
          this.typeList = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 获取物料集合 */
    initMaterialList() {
      let materialCategoryId = this.typeId
      Material.getMaterialList(materialCategoryId).then(res => {
        if (res.success) {
          let arr = []
          res.result.map(i => {
            let obj = {}
            obj.id = i.id
            obj.amortizationByDay = i.amortizationByDay == 1 ? true : false
            obj.name = i.name
            arr.push(obj)
          })
          this.tableData = arr
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 新增分类 */
    addMaterialType() {
      let data = {
        name: this.form.typeName
      }
      Material.postAddMaterialType(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '新增分类成功'
          });
          this.initMaterialTypeList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 删除分类 */
    delMaterialType() {
      let data = {
        id: this.typeId
      }
      Material.postDelMaterialType(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '删除成功'
          });
          this.initMaterialTypeList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 修改分类 */
    modMaterialType() {
      let data = {
        id: this.typeId,
        name: this.form.typeName
      }
      Material.postModMaterialType(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '修改成功'
          });
          this.initMaterialTypeList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 删除物料 */
    remove(id) {
      this.$confirm("物料删除后不可恢复，是否继续？", "确认删除物料", {
        confirmButtonText: "删除",
        cancelButtonText: "取消",
        confirmButtonClass: 'btn-red',
        cancelButtonClass: 'btn-gray'
      }).then(() => {
        let data = {
          id
        }
        Material.postDelMaterial(data).then(res => {
          if (res.success) {
            this.$message({
              type: 'success',
              message: '删除成功'
            });
            this.initMaterialList()
          } else {
            this.$message({
              type: 'error',
              message: res.message
            });
          }
        })
      });
    },

    /* 新增物料 */
    addMaterial() {
      let data = {
        materialCategoryId: this.typeId,
        name: this.form.materialName
      }
      Material.postAddMaterial(data).then(res => {
        if (res.success) {
          this.$message({
            type: 'success',
            message: '新增物料成功'
          });
          this.initMaterialList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    selectType(index, item) {
      this.activeIndex = index
      this.typeId = item.id
      this.initMaterialList()
    },

    changeStatus(id) {
      let data = {
        id
      }
      Material.postIsOpenDailySales(data).then(res => {
        if (res.success) {
          this.initMaterialList()
        } else {
          this.$message({
            type: 'error',
            message: res.message
          });
        }
      })
    },

    /* 
      返回新的command对象
      value即需要传递的额外参数
     */
    beforeHandleCommand(value,command){
      return {
        'value': value,
        'command':command
      }
    },

    handleCommand(command) {
      switch (command.command) {
        case "mod":
          this.typeId = command.value.id
          this.form.typeName = command.value.name
          this.isAddType = 3
          this.dialogTitle = '修改分类名称'
          this.dialogVisible = true
          break;
        case "delete":
          this.typeId = command.value.id
          this.$confirm("分类删除后不可恢复，是否继续？", "确认删除分类", {
            confirmButtonText: "删除",
            cancelButtonText: "取消",
            confirmButtonClass: 'btn-red',
            cancelButtonClass: 'btn-gray'
          }).then(() => {
            this.delMaterialType()
          });
          break;
      }
    },

    /* 开启新增物料 */
    openAddMaterial() {
      this.clear()
      this.isAddType = 2
      if (!this.typeId) return this.$message.error('请先选择分类')
      this.dialogTitle = '添加物料'
      this.dialogVisible = true
    },

    /* 开启新增分类 */
    addType() {
      this.clear()
      this.isAddType = 1
      this.dialogTitle = '新增分类'
      this.dialogVisible = true
    },

    handleClose() {
      this.dialogVisible = false
    },

    clear() {
      this.form.typeName = ''
      this.form.materialName = ''
    },

    confirm(formName) {
      this.$refs[formName].validate((valid) => {
        if (valid) {
          if (this.isAddType == 1) this.addMaterialType()
          if (this.isAddType == 2) this.addMaterial()
          if (this.isAddType == 3) this.modMaterialType()
          this.handleClose()
          this.clear()
        } else {
          console.log("error submit!!");
          return false;
        }
      });
    }
  }
}
</script>

<style lang='scss'>
.material-management {
  flex: 1;
  background-color: $bg-white;
  .material-container {
    height: 100%;
    display: flex;
    justify-content: center;
    .left-container {
      width: 288px;
      padding: 16px;
      box-sizing: border-box;
      border-right: 1px solid $bg-ShallowLightSnow;
      @include flex-column-center;
      .add-type-content {
        flex: 1;
        width: 256px;
        position: relative;
        overflow-y: auto;
        .search-type {
          margin-bottom: 16px;
          .el-input__prefix, .el-input__suffix {
            top: 2px;
          }
        }
        .type {
          height: 40px;
          @include flex-between;
          padding: 0px 12px;
          cursor: pointer;
          .type-title {
            @include flex-start;
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-grey;
            img {
              width: 20px;
              height: 20px;
              margin-right: 16px;
            }
          }
        }
        .active {
          background: $bg-Tab;
          .type-title {
            color: $color-DeepReddishBlue;
          }
        }
        .nothing-add {
          position: absolute;
          left: 50%;
          top: 50%;
          transform: translate(-50%,-50%);
          img {
            width: 104px;
            height: 87px;
          }
          p {
            font-size: $fs-small-l;
            font-weight: 400;
            color: $color-LightGrey;
            margin-top: 20px;
          }
        }
      }
    }
    .add-type {
      width: 200px;
    }
    .right-container {
      flex: 1;
      padding: 28px 19px;
      box-sizing: border-box;
      position: relative;
      .top-container {
        @include flex-between;
        margin-bottom: 20px;
        .title {
          padding-left: 10px;
          font-size: $fs-medium-s;
          color: $color-BlackGrey;
          border-left: 4px solid $color-DeepReddishBlue;
        }
        .search {
          display: flex;
          .add {
            margin-left: 12px;
            padding: 0;
          }
        }
      }
      .nothing {
        position: absolute;
        left: 50%;
        top: 50%;
        transform: translate(-50%,-50%);
        img {
          width: 157px;
          height: 157px;
        }
        p {
          font-size: $fs-small-l;
          font-weight: 400;
          color: $color-LightGrey;
          margin-top: 24px;
        }
      }
    }
  }
  .el-dropdown-link {
    @include extend-click;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label:before {
    display: none;
  }
  .el-form-item.is-required:not(.is-no-asterisk)
    .el-form-item__label-wrap
    > .el-form-item__label:before,
  .el-form-item.is-required:not(.is-no-asterisk) > .el-form-item__label::after {
    content: "*";
    color: $bg-Required;
    margin-left: 4px;
  }
  .el-dialog__header,
  .el-dialog__footer {
    border: none;
  }
  .el-dialog__footer {
    @include flex-end;
  }
}
.mod {
  color: $color-grey;
  font-size: $fs-small-l;
}
.delete {
  color: $color-Crimson;
  font-size: $fs-small-l;
}
</style>
